import {createSelector} from 'reselect';

const getApplication = state => state.application;

const gameConfigSelector = createSelector(
  getApplication,
  (application = {}) => {
    const {details} = application;
    const {id, playerLimit, audience, isPublished, treasureChest, leaderboard} = details || {};

    return {
      id,
      playerLimit: playerLimit || 4,
      isAudienceAllowed: audience,
      hasTreasureChest: treasureChest,
      hasLeaderboard: leaderboard,
      isPublished,
    };
  }
);
export default gameConfigSelector;
